import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { LanguageService } from '../../../../shared/services/language.service';
import { UserService } from '../../../../shared/services/user.service';
import { ProductionStatusService } from '../../_api/services/production-status-service';

let self: CustomReport2Component = null;

@Component({
  selector: 'app-custom-report2',
  templateUrl: './custom-report2.component.html',
  styleUrls: ['./custom-report2.component.css']
})
export class CustomReport2Component implements OnInit {

  private _showPublicly = false;
  @Input() set showPublicly(v: boolean) {
    this._showPublicly = v;
  }
  get showPublicly() {
    return this._showPublicly;
  }

  @Input() showTitle: boolean;
  columnCount: number;
  rowHeight: string;
  report: any;
  reportData: any;
  rows = [];

  private _reportId: number;
  @Input() set reportId(n: number) {
    this._reportId = n;
    if (this.isInitialized) {
      this.refresh();
    }
    this.scrollViewHeight = (window.innerHeight - 160);
  }

  get reportId(): number {
    return this._reportId; 
  }

  @Output() selectedReportReportElementIdChanged = new EventEmitter<any>();

  @Output() refreshCallbackChanged = new EventEmitter<any>();

  scrollViewHeight = 200;

  private isInitialized = false;

  constructor(public ls: LanguageService, public us: UserService, public ds: ProductionStatusService) {
    self = this;
    this.showTitle = false;
    this.columnCount = 0;
    this.rowHeight = "2:1";
    this.report = null;
    this.reportData = null;
  }

  ngOnInit() {
    this.isInitialized = true;
    this.refresh();
  }


  refresh() {
    self.columnCount = 0;
    self.rows = [];
    self.report = null;
    self.reportData = null;
    let theReport = null;
    self.ds.getCustomReport2(self._reportId, self.showPublicly).toPromise().then((data) => {
      if (data.Report !== null) {
        theReport = data.Report;
        self.columnCount = data.Report.ColumnCount;
        self.report = data.Report;
        self.reportData = data.Data;

        let colCount = 0, rowCount = 0;
        for (let i = 0; i < self.report.ReportReportElements.length; i++) {
          if (i % self.report.ColumnCount === 0) {
            colCount = 0;
            self.rows.push([]);
            rowCount++;
          }
          self.rows[rowCount - 1].push(i);
          colCount++;
        }
        for (let i = 0; i < (self.report.ColumnCount - colCount); i++) {
          self.rows[rowCount - 1].push(null);
        }
      }
      else {
        self.columnCount = 0;
        self.report = null;
        self.reportData = null;
        notify(self.ls.LNG('Label.AccessDenied'), "error", 10000);
      }
    }).catch((error) => {
      theReport = null;
      notify(error, "error", 1000);
    }).finally(() => {
      if (self._showPublicly) {
        self.refreshCallbackChanged.emit({
          sleepTimeInMilliSeconds: theReport !== null ? theReport.RefreshIntervalInMinutes * 60000 : 15 * 60000,//if the data retrieval failed wait 15 minutes before trying again
          refreshFunction: self.refresh
        });
      }
    });
  }

  showDetails(reportReportElement: any) {
    this.selectedReportReportElementIdChanged.emit({
      Name: `${reportReportElement.Name} - ${this.ls.LNG('Label.Details').toLowerCase()}`,
      Description: reportReportElement.Description,
      ReportReportElementId: reportReportElement.ReportReportElementId,
      MissingConfiguration: reportReportElement.MissingConfiguration,
      ReportElement: { CustomElementNumber: -2 }
    });
  }
}
